import lodashGet from "lodash/get";
import React, { type ComponentPropsWithoutRef } from "react";
import {
  type UnwrapArray,
  type DeepValue,
  type PathToArray,
  pillarTableColumnArrayValue,
} from "shared/components/pillar-table/columns/array/PillarTableColumnArray";
import type { PillarTableBaseColumnCellValuePathProps } from "shared/components/pillar-table/columns/PillarTableColumn";
import { usePillarTableRowContext } from "shared/components/pillar-table/row/PillarTableRowContext";
import type { DeepKeys } from "shared/types/deepkeys";

export const PillarTableColumnArraySum = <T,>({
  cellValuePath,
  sumPath,
}: {
  sumPath?: DeepKeys<UnwrapArray<DeepValue<T, PathToArray<T>>>>;
} & Omit<PillarTableBaseColumnCellValuePathProps<T>, "cellValuePath"> & {
    cellValuePath?: PathToArray<T>;
  } & ComponentPropsWithoutRef<"div">) => {
  const rowContext = usePillarTableRowContext();
  const arrayValue = pillarTableColumnArrayValue({
    rowContext,
    cellValuePath,
  });
  const toSafeNumber = (value: unknown) => {
    if (typeof value === "boolean") {
      return 0;
    }
    const numeric = Number(value);
    return Number.isFinite(numeric) ? numeric : 0;
  };

  const sum = Array.isArray(arrayValue)
    ? arrayValue.reduce(
        (acc: number, item: DeepValue<T, PathToArray<T>>) =>
          acc + toSafeNumber(sumPath ? lodashGet(item, sumPath) : item),
        0,
      )
    : 0;

  return <>{sum}</>;
};
